import { z } from "zod"

export const ChangeLogSnapshotSchema = z.object({
  content: z.string(),
  title: z.string().nullable(),
})

export const ChangeLogResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  companyId: z.bigint().transform(String),
  model: z.string(),
  recordId: z.bigint().transform(String),
  snapshot: z.record(
    z.string(),
    z.union([z.string(), z.number(), z.boolean(), z.null(), z.array(z.unknown())]),
  ),
  employeeId: z
    .bigint()
    .nullable()
    .transform((value) => value?.toString()),
  employeeName: z.string().nullable(),
  employeeEmail: z.string().nullable(),
  adminId: z
    .bigint()
    .nullable()
    .transform((value) => value?.toString()),
  createdAt: z.date().transform((value) => value.toISOString()),
})

export const ChangeLogsResponseDataSchema = z.array(ChangeLogResponseDataSchema)
